module.exports = __webpack_public_path__ + "static/5aafb94771ec3ac2179c3e2cc8ea9f09d76bae0f7f39c64e87635c6567568512-48efb1cdce17a49eae2f4c186262d2de.png";